// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"635173b7","615":"74dc8526","824":"02ce0138","874":"3a8da734"}[chunkId] + ".chunk.js";
};